import React from "react"

import BaseCard, { BaseProps } from "../../../components/CardList/Card"
import Info from "./Info"

export default function Card(props: BaseProps) {
  return <BaseCard info={<Info {...props} />} {...props} />
}
